import { btn } from '../ui';

export default function ConfirmDialog({ open, title, lines = [], confirmLabel, onConfirm, onCancel, children }) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center p-4 z-50"
      onClick={onCancel}
    >
      <div
        role="dialog"
        aria-modal="true"
        className="bg-white rounded-lg shadow-lg max-w-md w-full p-5"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="font-semibold mb-2">{title}</h3>
        <ul className="text-sm text-gray-600 space-y-1 mb-4 list-disc pl-5">
          {lines.map((line, i) => <li key={i}>{line}</li>)}
        </ul>
        {children}
        <div className="flex gap-2 justify-end">
          <button onClick={onCancel} className={btn.cancel}>Cancel</button>
          <button onClick={onConfirm} className={btn.primary}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
